import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { usePartnerRole } from "@/hooks/usePartnerRole";
import { PartnerLayout } from "@/components/partner/PartnerLayout";
import { Loader2, ShieldOff, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PartnerRouteProps {
  children: React.ReactNode;
}

export function PartnerRoute({ children }: PartnerRouteProps) {
  const { user, loading: authLoading, signOut } = useAuth();
  const { isPartnerAdmin, partnerData, isLoading: roleLoading } = usePartnerRole();

  if (authLoading || roleLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!isPartnerAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Verificar se parceiro está ativo
  if (partnerData && !partnerData.is_active) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center space-y-4 p-8">
          <ShieldOff className="h-16 w-16 text-destructive mx-auto" />
          <h1 className="text-2xl font-bold">Acesso Bloqueado</h1>
          <p className="text-muted-foreground max-w-md">
            Sua conta de parceiro foi desativada pelo administrador.
            Entre em contato para mais informações.
          </p>
          <Button onClick={() => signOut()}>
            <LogOut className="h-4 w-4 mr-2" />
            Sair
          </Button>
        </div>
      </div>
    );
  }

  return <PartnerLayout>{children}</PartnerLayout>;
}

